import apiClient from "./apiClient";

/**
 * Log a new break entry for an employee
 * @param {string} companyCode
 * @param {object} payload - { employeeId, employeeName, durationSeconds }
 */
export const createBreakEntry = async (companyCode, payload) => {
  try {
    const res = await apiClient.post(
      "/api/break-logs/entries",
      { ...payload, companyCode },
      {
        headers: companyCode ? { "x-active-company-code": companyCode } : {},
      }
    );
    return res;
  } catch (error) {
    console.error("[BreakService] createBreakEntry error:", error);
    return { success: false, message: error.message || "Failed to log break entry" };
  }
};

/**
 * Get all employee break logs and over-limit violations for today (Admin view)
 * @param {string} companyCode
 */
export const getTodayBreaks = async (companyCode) => {
  try {
    const res = await apiClient.get("/api/break-logs/today", {
      params: { companyCode },
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[BreakService] getTodayBreaks error:", error);
    return { success: false, logs: [], overLimit: [] };
  }
};

/**
 * Get today's total cumulative break time for a specific employee
 * @param {string} companyCode
 * @param {string} employeeId
 */
export const getEmployeeTodayBreak = async (companyCode, employeeId) => {
  try {
    const res = await apiClient.get("/api/break-logs/employees/today", {
      params: { companyCode, employeeId },
      headers: companyCode ? { "x-active-company-code": companyCode } : {},
    });
    return res;
  } catch (error) {
    console.error("[BreakService] getEmployeeTodayBreak error:", error);
    return { success: false, totalSeconds: 0, isOverLimit: false };
  }
};
